import { Box, Heading } from '@chakra-ui/react';
import React from 'react';

interface Props {
  query: string;
}

export default function TextResults({ query }: Props) {
  return (
    <Box className={'TextResults'}>
      <Heading size={'sm'}>
        Showing FFLs that match &ldquo;{query}&rdquo; ...
      </Heading>
    </Box>
  );
}
